import { Component, ElementRef, EventEmitter, HostListener, OnInit, Output, ViewChild, ViewContainerRef } from '@angular/core';
import * as moment from 'moment';
import { AgendaService } from 'src/app/services/agenda/agenda.service';
import { AlarmsService } from 'src/app/services/alarms/alarms.service';
import { ModalService } from 'src/app/services/modal/modal.service';
import { PatientService } from 'src/app/services/patient/patient.service';
import { RechercheMultiService } from 'src/app/services/recherche/recherche-multi.service';
import { SnackbarService } from 'src/app/services/snackbar/snackbar.service';
import { StringUtilsService } from 'src/app/services/string-utils/string-utils.service';
import { SortEnum } from 'src/app/utils/enums/sort-enum';
import { AlarmsPatient } from 'src/app/utils/interfaces/new/alarms-patient.interface';
import { DestinataireAlarme } from 'src/app/utils/interfaces/new/destinataire-alarmes.interface';
import { FichePatient } from 'src/app/utils/interfaces/new/fiche-patient.interface';
import { Filtres } from 'src/app/utils/interfaces/new/filtres.interface';
import { KeyColumn } from 'src/app/utils/interfaces/new/key-column.interface';
import { Paginated } from 'src/app/utils/interfaces/new/paginated.interface';
import { RechercheMultiCriteres } from 'src/app/utils/interfaces/new/recherche';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-alarme',
  templateUrl: './alarme.fragment.html',
  styleUrls: ['./alarme.fragment.scss', '../modal.fragment.scss']
})
export class AlarmeFragment implements OnInit {

  @ViewChild('modalBody') public modalBody: ElementRef;
  @ViewChild('outsideModal') public outsideModal: ElementRef;

  public patientId: string
  public patientInfos: string;
  public modalTitle: string;
  public modalTitrePatient: string;
  public modalFichePatient: FichePatient;
  recherchesPatient: Paginated<RechercheMultiCriteres>;
  public currentProfil: any;
  public listAlarmesPatient: Paginated<AlarmsPatient>;
  public listRDV: Paginated<any>;

  public alarmeColumnTable: KeyColumn[] = [];
  public rdvColumnTable: KeyColumn[] = [];
  public searchColumnTable  = [
    { title: 'Recherche', data: 'titre' },
  ];

  public rdvTable: any = {};
  public filtre: Filtres = {
    perpage: 2,
    currentPage: 1
  };

  @Output() public closeEmitter = new EventEmitter();
  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event): void {
    if (!environment.closeModalOnClickOutside) {
      return;
    }

    if (!this.modalBody.nativeElement.contains(event.target) && this.outsideModal.nativeElement.contains(event.target)) {
      this.closeAlarmeModal();
    }
  }

  constructor(
    public viewContainerRef: ViewContainerRef,
    public modalSrv: ModalService,
    private agendaSrv: AgendaService,
    private alarmsSrv: AlarmsService,
    private patientSrv: PatientService,
    private _rechercheMulti: RechercheMultiService,
    private _strUtilsSrv: StringUtilsService,
    private _snack: SnackbarService
  ) { }

  async ngOnInit(): Promise<void> {
    if (this.modalTitrePatient && this.modalFichePatient) {
      this.patientInfos = `${this.modalTitrePatient} ${this.modalFichePatient.nom.toLocaleUpperCase()}  ${this._strUtilsSrv.uppercaseFirstCharString(this.modalFichePatient.prenom)} - ${moment(this.modalFichePatient.dateNaissance).format('DD/MM/YYYY')} - ${moment().diff(this.modalFichePatient.dateNaissance, 'years').toString()} ans - ${this.modalFichePatient.sexe}`;
    }
    const currentProfilStr = localStorage.getItem('currentProfil');
    if (currentProfilStr && currentProfilStr !== '') {
      this.currentProfil = JSON.parse(currentProfilStr);
    }
    this.initTableAlarmes();
    this.initTableRDV();
  }

  public async initTableAlarmes(): Promise<void> {
    const today = moment().format("YYYY-MM-DD");
    // const listAlarmDay = await this.patientSrv.findPatientAlarmes(this.modalFichePatient.id, this.filtre, true);
    // const alarmDay = listAlarmDay.objects.filter((alarme) => (moment(alarme.dateAlarme).format("YYYY-MM-DD") === today));
    // this.listAlarmesPatient = { perpage: 2, page: listAlarmDay.page, total: alarmDay.length, objects: alarmDay };
    this.alarmeColumnTable = [
      { title: 'Date', data: 'dateAlarme' },
      { title: 'Description', data: 'alarme' },
      { title: 'Marquer comme lue', data: null },
    ];
  }

  public async initTableRDV(): Promise<void> {
    const status = await this.agendaSrv.getStatus();
    let notHonored: string;
    for (const statut of status) {
      if (statut.label === 'Non honoré') {
        notHonored = statut.id;
      }
    }

    this.listRDV = await this.agendaSrv.searchEvents(this.filtre.currentPage, this.modalFichePatient.id, null, null, null, null, null, null, null, notHonored, null, null, 2);
    let dates: any;
    let hours: string;
    let ressources: string;
    let descriptions: string;

    for (const [index, infos] of this.listRDV.objects.entries()) {
      if (infos.dateDebut) {
        const momentDate = moment(infos.dateDebut);
        dates = momentDate.format('DD/MM/YYYY');
        hours = momentDate.format('HH:mm');
      } else {
        dates = '';
        hours = '';
      }

      if (infos.ressourses) {
        for (const ressource of infos.ressourses) {
          if (ressource.nom) {
            ressources = ressource.nom;
          } else {
            ressources = '';
          }
          if (ressource.description) {
            descriptions = ressource.description;
          } else {
            descriptions = '';
          }
        }
      }

      this.rdvTable = {
        jours: dates,
        hours: hours,
        ressources: ressources,
        description: descriptions
      }
      this.listRDV.objects[index] = this.rdvTable;
    }

    this.rdvColumnTable = [
      { title: 'Date', data: 'jours' },
      { title: 'Heures', data: 'hours' },
      { title: 'Ressources', data: 'ressources' },
      { title: 'Description', data: 'description' },
    ];
  }

  public async deleteAlarme(alarme: AlarmsPatient): Promise<void> {
    const confirmModal = this.modalSrv.openModalConfirmation(this.viewContainerRef, "Annulation", "Avez-vous traité cette alarme ?");
    confirmModal.instance.closeEmitter.subscribe(async (res: boolean) => {
      if (res) {
        const loader = this.modalSrv.openLoading(this.viewContainerRef);
        try {
          const update: DestinataireAlarme  = {
              idAlarme: alarme.id,
              idProfil: this.currentProfil.idProfil,
              processed: true,
              view: true,
            };
          // On marque l'alarme comme traitée pour le profil
          if (update) {
            await this.alarmsSrv.updateStatus(update);
            await this.initTableAlarmes();
            // On retire l'alarme de la liste locale
            this.listAlarmesPatient.objects = this.listAlarmesPatient.objects.filter((alarm) => alarm.id !== alarme.id);
          } else {
            // Do nothing
            this._snack.openSnackBar('Impossible de marquer cette alarme comme traitée pour vous.\nElle est probablement globale (pas de destinataire).\n\n Vous pouvez la modifier/supprimer depuis les alarmes patient.');
            loader.destroy();
            return;
          }
          loader.destroy();
          this.modalSrv.close(loader);
        } catch (e) {
          loader.destroy();
          this.modalSrv.close(loader);
          throw e;
        }
      }
    });
  }

  public async onChangePageAlarme(value: any): Promise<void> {
    this.filtre.currentPage = value;
    this.initTableAlarmes();
  }

  public async onChangePageSearch(value: any): Promise<void> {
    this.recherchesPatient = await this._rechercheMulti.listRecherchesForPatient(this.patientId, {
      perpage: 3,
      currentPage: value,
      sortOrder: SortEnum.ASC,
      sortBy: 'titre'
    });
  }

  public async onChangePageRDV(value: any): Promise<void> {
    this.filtre.currentPage = value;
    this.initTableRDV();
  }

  public closeAlarmeModal(): void {
    this.closeEmitter.emit(null);
  }
}
